import { configureStore } from '@reduxjs/toolkit';

// ROUTING KIT-QR SCREENS
import RouterSlice from '../slices/routerSlice';
// HANDLE USER INFORMATION
import UserSlice from '../slices/userSlice';
// HANDLE BUSSINES INFORMATION
import BussinessSlice from '../slices/bussinessSlice';
// HANDLE BANK INFORMATION
import BankSlice from '../slices/bankSlice';
// HANDLE BLOCKCHAIN INFORMATION
import BlockchainSlice from '../slices/blockchainSlice';

export default configureStore({
    reducer: {
        user: UserSlice,
        bank: BankSlice,
        router: RouterSlice,
        bussines: BussinessSlice,
        blockchain: BlockchainSlice
    }
})